export class PlanAccion {
    id: number;
    nombre: string;
    fechinicio: Date;
    fechafin: Date;
    descripcion: string;
    idResponsable: number;
    
}